export const CONSTANT = {
    OMYFOOD: 'OhMyFood',
    OMYFOOD_WEB_LINK: 'https://omyfood.io',
};

export const SEO = {
    HOME_PAGE_TITLE: `OMF - See the Flavor. Crave the Taste. Delivered Fast | ${CONSTANT.OMYFOOD}`,

    LANDING_PAGE: {
        TITLE: `Landing Page | ${CONSTANT.OMYFOOD}`,
        DESCRIPTION: 'OMF is your go-to platform for online food delivery, offering a wide range of cuisines with fast, reliable service.',
        CANONICAL: `${CONSTANT.OMYFOOD_WEB_LINK}`,
        OG: {
            TYPE: 'website',
            URL: `${CONSTANT.OMYFOOD_WEB_LINK}`,
            SITE_NAME: CONSTANT.OMYFOOD,
        },
        KEYWORDS: 'OMF food delivery, online food ordering, watch food reels, partner with food delivery app, join OMF, food delivery near me, fast food online, restaurant delivery, vendor signup, food cravings',
    },

    SIGNUP_PAGE: {
        TITLE: `Signup | ${CONSTANT.OMYFOOD}`,
        DESCRIPTION: `Join ${CONSTANT.OMYFOOD} to get delicious food delivered to your doorstep. Easy sign-up, fast service, fresh flavors.`,
        CANONICAL: `${CONSTANT.OMYFOOD_WEB_LINK}/signup`,
        OG: {
            TYPE: 'website',
            URL: `${CONSTANT.OMYFOOD_WEB_LINK}/signup`,
            SITE_NAME: CONSTANT.OMYFOOD,
        },
        KEYWORDS: 'OMF signup, join food delivery app, create food account, vendor registration, customer signup, online food service, OMF account, restaurant partner signup, food delivery app registration, get started with OMF',
    },


    LOGIN_PAGE: {
        TITLE: `Login | ${CONSTANT.OMYFOOD}`,
        DESCRIPTION: `Log in to your ${CONSTANT.OMYFOOD} account to explore food reels, order your favorites, and enjoy seamless delivery.`,
        CANONICAL: `${CONSTANT.OMYFOOD_WEB_LINK}/login`,
        OG: {
            TYPE: 'website',
            URL: `${CONSTANT.OMYFOOD_WEB_LINK}/login`,
            SITE_NAME: CONSTANT.OMYFOOD,
        },
        KEYWORDS:'OMF login, food delivery login, customer login, vendor login, access food reels, order food online, login to OMF, food app sign in, restaurant portal login, online food service account'
    },

    HOME_PAGE: {
        TITLE: ` Home Page | ${CONSTANT.OMYFOOD}`,
        DESCRIPTION: 'Explore trending food reels, revisit past orders, unlock personalized offers, and find top restaurants near you — all on OMF, your food discovery and delivery hub.',
        CANONICAL: `${CONSTANT.OMYFOOD_WEB_LINK}/Dashboard`,
        OG: {
            TYPE: 'website',
            URL: `${CONSTANT.OMYFOOD_WEB_LINK}/Dashboard`,
            SITE_NAME: CONSTANT.OMYFOOD,
            TITLE: `${CONSTANT.OMYFOOD} - Discover Food, Watch Reels, Get Offers & Order Nearby`,
            DESCRIPTION: 'From trending food reels to local restaurants, OMF lets you crave, discover, and order — fast.'
        },
        TWITTER:{
            TITLE: `${CONSTANT.OMYFOOD} - Food Reels, Offers, Orders & Nearby Restaurants`,
            DESCRIPTION: 'Food videos, past orders, offers, and top restaurants — all in one place. Explore now on OMF.'
        },
        KEYWORDS:'food discovery, food reels, food delivery, order food online, restaurants near me, personalized food offers, food trends, Omyfood, food videos, nearby food'
    },

    REELS_PAGE: {
        TITLE: `Reels | ${CONSTANT.OMYFOOD}`,
        DESCRIPTION:
      'Browse trending food reels on OMF. Discover mouth-watering dishes, creative recipes, and popular bites. Watch, crave, and order with fast delivery.',
        CANONICAL: `${CONSTANT.OMYFOOD_WEB_LINK}/reels`,
        OG: {
            TYPE: 'website',
            TITLE: `Reels | ${CONSTANT.OMYFOOD}`,
            DESCRIPTION: 'Explore delicious food reels on OMF. Crave the taste. Delivered fast.',
            URL: `${CONSTANT.OMYFOOD_WEB_LINK}/reels`,
            SITE_NAME: CONSTANT.OMYFOOD,
        },  
        TWITTER: {
            CARD: 'summary_large_image',
            TITLE: `Explore Top Food Reels | ${CONSTANT.OMYFOOD}`,
            DESCRIPTION: 'Get inspired by food videos and short reels on OMF. Fast delivery, fresh cravings.',
        },
        LD_JSON: {
            '@context': 'https://schema.org',
            '@type': 'VideoObject',
            'name': `Trending Food Reels | ${CONSTANT.OMYFOOD}`,
            'description': 'Watch trending food videos and reels on OMF. See the flavor. Crave the taste. Delivered fast.',
            'uploadDate': new Date().toISOString(),
            'embedUrl': `${CONSTANT.OMYFOOD_WEB_LINK}/reels`,
            'duration': 'PT1M',
            'publisher': {
                '@type': 'Organization',
                'name': CONSTANT.OMYFOOD,
                'logo': {
                    '@type': 'ImageObject',
                    'url': 'https://omyfood.io/OMF_logo_bg.png',
                    'width': 600,
                    'height': 60
                }
            },
            'interactionStatistic': {
                '@type': 'InteractionCounter',
                'interactionType': { '@type': 'WatchAction' },
                'userInteractionCount': 1000
            }
        },
        KEYWORDS:'food reels, food videos, watch food online, trending recipe videos, viral food clips, OMF reels, cooking reels, restaurant videos, order from videos, delicious food shorts'
    },

    CART_PAGE: {
        TITLE: `Cart | ${CONSTANT.OMYFOOD}`,
        DESCRIPTION: 'OMF is your go-to platform for online food delivery, offering a wide range of cuisines with fast, reliable service.',
        CANONICAL: `${CONSTANT.OMYFOOD_WEB_LINK}/cart`,
        OG: {
            TYPE: 'website',
            URL: `${CONSTANT.OMYFOOD_WEB_LINK}/cart`,
            SITE_NAME: CONSTANT.OMYFOOD,
        },
        KEYWORDS:'food cart, online food cart, order food online, restaurant checkout, Omyfood cart, food delivery cart, review food order, edit food cart, food basket, checkout food order'
    },

    ORDER_INFO_PAGE: {
        TITLE: `Previous Orders | ${CONSTANT.OMYFOOD}`,
        DESCRIPTION: 'View details of your past orders including item breakdown, delivery status, and total charges. Revisit your cravings anytime with OMF.',
        CANONICAL: `${CONSTANT.OMYFOOD_WEB_LINK}/orders`,
        OG: {
            TYPE: 'website',
            URL: `${CONSTANT.OMYFOOD_WEB_LINK}/orders`,
            SITE_NAME: CONSTANT.OMYFOOD,
        },
        KEYWORDS:'previous food orders, order history, reorder food, OMF past orders, review past orders, food delivery history, rate food order, reorder favorites, track order status, order receipts'
    },

    TERMS_AND_CONDITIONS_PAGE: {
        TITLE: `Terms and Conditions | ${CONSTANT.OMYFOOD}`,
        DESCRIPTION: 'Read the terms and conditions of using OMF\'s food discovery and delivery platform. Understand our policies regarding user conduct, services, and legal disclaimers.',
        CANONICAL: `${CONSTANT.OMYFOOD_WEB_LINK}/terms-and-conditions`,
        OG: {
            TYPE: 'website',
            URL: `${CONSTANT.OMYFOOD_WEB_LINK}/terms-and-conditions`,
            SITE_NAME: CONSTANT.OMYFOOD,
        },
        KEYWORDS:'terms and conditions, user agreement, service terms, omyfood terms, usage policy, legal terms, online food service terms, user responsibilities, omyfood rules, food ordering terms'
    },

    PRIVACY_POLICY_PAGE: {
        TITLE: `Privacy Policy | ${CONSTANT.OMYFOOD}`,
        DESCRIPTION: 'Learn about our privacy practices and how we collect, use, and protect your personal information. Understand our commitment to data security and privacy.',
        CANONICAL: `${CONSTANT.OMYFOOD_WEB_LINK}/privacy-policy`,
        OG: {
            TYPE: 'website',
            URL: `${CONSTANT.OMYFOOD_WEB_LINK}/privacy-policy`,
            SITE_NAME: CONSTANT.OMYFOOD,
        },
        KEYWORDS:'privacy policy, data protection, personal information, user data, omyfood privacy, data usage policy, user rights, GDPR compliance, secure transactions, privacy terms'
    },

    PROFILE_PAGE: {
        TITLE: `Profile | ${CONSTANT.OMYFOOD}`,
        DESCRIPTION: `Manage your ${CONSTANT.OMYFOOD} account settings, update personal details, track activity, and personalize your food experience.`,
        CANONICAL: `${CONSTANT.OMYFOOD_WEB_LINK}/profile`,
        OG: {
            TYPE: 'website',
            URL: `${CONSTANT.OMYFOOD_WEB_LINK}/profile`,
            SITE_NAME: CONSTANT.OMYFOOD,
        },
        TWITTER: {
            TITLE: `Your Profile | ${CONSTANT.OMYFOOD}`,
            DESCRIPTION: 'Access your profile, update preferences, and personalize your food journey on OMF.',
        },
        KEYWORDS: 'OMF profile, user profile, manage account, update profile, food preferences, customer dashboard, profile settings, edit food account, personal info, omyfood user page'
    },

    FORGOT_PASSWORD_PAGE: {
        TITLE: `Forgot Password | ${CONSTANT.OMYFOOD}`,
        DESCRIPTION: `Recover your ${CONSTANT.OMYFOOD} account password easily. Reset access and get back to enjoying your favorite meals.`,
        CANONICAL: `${CONSTANT.OMYFOOD_WEB_LINK}/forget-password`,
        OG: {
            TYPE: 'website',
            URL: `${CONSTANT.OMYFOOD_WEB_LINK}/forget-password`,
            SITE_NAME: CONSTANT.OMYFOOD,
        },
        TWITTER: {
            TITLE: `Reset Your Password | ${CONSTANT.OMYFOOD}`,
            DESCRIPTION: 'Trouble signing in? Reset your OMF password and regain access to your food cravings.',
        },
        KEYWORDS: 'forgot password, reset food app password, recover OMF account, password assistance, regain access, food delivery login help, password recovery, omyfood reset password, reset login credentials, account help'
    },

    VERIFY_OTP_PAGE: {
        TITLE: `Verify OTP | ${CONSTANT.OMYFOOD}`,
        DESCRIPTION: `Enter the One-Time Password sent to your registered contact to verify your identity and securely access your ${CONSTANT.OMYFOOD} account.`,
        CANONICAL: `${CONSTANT.OMYFOOD_WEB_LINK}/verify-otp`,
        OG: {
            TYPE: 'website',
            URL: `${CONSTANT.OMYFOOD_WEB_LINK}/verify-otp`,
            SITE_NAME: CONSTANT.OMYFOOD,
        },
        TWITTER: {
            TITLE: `Verify Your OTP | ${CONSTANT.OMYFOOD}`,
            DESCRIPTION: 'Securely access your OMF account by verifying the One-Time Password sent to you.',
        },
        KEYWORDS: 'verify otp, otp login, secure login, account verification, OMF otp, food app verification, one time password, user authentication, secure access, omyfood login'
    },

    PAYMENT_PAGE: {
        TITLE: `Payment | ${CONSTANT.OMYFOOD}`,
        DESCRIPTION: `Complete your payment securely on ${CONSTANT.OMYFOOD}. Fast, encrypted transactions for your food orders with multiple payment options.`,
        CANONICAL: `${CONSTANT.OMYFOOD_WEB_LINK}/Payment`,
        OG: {
            TYPE: 'website',
            URL: `${CONSTANT.OMYFOOD_WEB_LINK}/Payment`,
            SITE_NAME: CONSTANT.OMYFOOD,
        },
        TWITTER: {
            TITLE: `Secure Payment | ${CONSTANT.OMYFOOD}`,
            DESCRIPTION: 'Make fast and secure food order payments with multiple options on OMF.',
        },
        KEYWORDS: 'OMF payment, food order payment, secure checkout, online payment, food delivery transaction, UPI payment, credit card checkout, wallet payment, omyfood pay, fast food payment'
    },

    PAYMENT_SUCCESS_PAGE: {
        TITLE: `Payment Success | ${CONSTANT.OMYFOOD}`,
    },

    CHANGE_PASSWORD_PAGE: {
        TITLE: `Change Password | ${CONSTANT.OMYFOOD}`,
        DESCRIPTION: `Securely update your password on ${CONSTANT.OMYFOOD} to keep your account safe. Quick, simple, and protected password change process.`,
        OG: {
            TYPE: 'website',
            SITE_NAME: CONSTANT.OMYFOOD,
        },
        TWITTER: {
            TITLE: `Update Password | ${CONSTANT.OMYFOOD}`,
            DESCRIPTION: 'Change your password easily on OMF. Your account’s security is our priority.',
        },
        KEYWORDS: 'change password, update password, reset login credentials, omf password change, secure account, update login info, food app password, omyfood account settings, password update form, keep account safe'
    },

    EDIT_PROFILE_PAGE: {
        TITLE: `Edit Profile | ${CONSTANT.OMYFOOD}`,
        DESCRIPTION: `Update your personal information, contact details, and preferences on ${CONSTANT.OMYFOOD}. Keep your food experience personalized and up to date.`,
        CANONICAL: `${CONSTANT.OMYFOOD_WEB_LINK}/profilesettings`,
        OG: {
            TYPE: 'website',
            URL: `${CONSTANT.OMYFOOD_WEB_LINK}/profilesettings`,
            SITE_NAME: CONSTANT.OMYFOOD,
        },
        TWITTER: {
            TITLE: `Edit Your Profile | ${CONSTANT.OMYFOOD}`,
            DESCRIPTION: 'Manage your OMF profile — update name, email, address, and preferences easily.',
        },
        KEYWORDS: 'edit profile, update personal info, change user details, omf profile update, manage profile, food app account, user info, name email update, profile customization, omyfood user settings'
    },

    FOOD_LIST_PAGE: {
        TITLE: `Food | ${CONSTANT.OMYFOOD}`,
        DESCRIPTION: `Browse popular dishes, watch short food videos, and order your favourites on ${CONSTANT.OMYFOOD}. Fresh, fast delivery from top‑rated restaurants near you.`,   
        
        OG: {
            TYPE: 'website',
            SITE_NAME: CONSTANT.OMYFOOD,
            TITLE: `Food Near You • ${CONSTANT.OMYFOOD}`,
            DESCRIPTION: 'Discover trending dishes and order in a tap — watch, crave, repeat.',
        },
        
        TWITTER: {
            TITLE: `Trending Dishes Around You | ${CONSTANT.OMYFOOD}`,
            DESCRIPTION: 'Watch food reels, see ratings and distance, and order instantly on OMF.',
        },
        KEYWORDS: 'food near me, order food online, trending dishes, food videos, food search, OMF foods, watch and order, quick delivery, nearby restaurants'
    },

    OFFERS_PAGE: {
        TITLE: `Offers | ${CONSTANT.OMYFOOD}`,
        DESCRIPTION: `Browse the best discounts and cashback deals from top‑rated restaurants on ${CONSTANT.OMYFOOD}. Save more and order faster.`,

        OG: {
            TYPE: 'website',
            URL:  `${CONSTANT.OMYFOOD_WEB_LINK}/offers`,
            SITE_NAME: CONSTANT.OMYFOOD,
            TITLE: `Today's Food Deals • ${CONSTANT.OMYFOOD}`,
            DESCRIPTION: 'Up to 60 % OFF! Claim coupons and order in one tap.',
        },

        TWITTER: {
            TITLE: `Grab Food Offers Around You | ${CONSTANT.OMYFOOD}`,
            DESCRIPTION: 'Explore limited‑time discounts and cashback on your favourite meals.',
        },
        KEYWORDS: 'restaurant offers, food coupons, discounts near me, cashback on food, OMF deals, order food cheap, save on meals, limited‑time offers, ohmyfood discounts, food delivery deals'
    },

    POSTS_PAGE: {
        TITLE: `Posts | ${CONSTANT.OMYFOOD}`,
        DESCRIPTION:
    `Watch bite‑sized food videos from local restaurants, discover new dishes, and order straight from the reel on ${CONSTANT.OMYFOOD}.`,

        OG: {
            TYPE: 'website',
            SITE_NAME: CONSTANT.OMYFOOD,
            TITLE: `Food Reels Near You • ${CONSTANT.OMYFOOD}`,
            DESCRIPTION: 'Scroll, crave, and order — all in one place.',
        },

        TWITTER: {
            TITLE: `Watch Food Reels & Order Instantly | ${CONSTANT.OMYFOOD}`,
            DESCRIPTION: 'Discover trending dishes through short videos and order with a tap.',
        },
        KEYWORDS:
    'food reels, short food videos, restaurant posts, watch and order food, food discovery, OMF reels, trending dishes, local restaurant videos, food video feed, order from video'
    },

    RESTAURANT_PAGE: {
        TITLE: `Restaurants | ${CONSTANT.OMYFOOD}`,
        DESCRIPTION:
    `Discover top-rated restaurants near you. Explore menus, ratings, and order instantly with ${CONSTANT.OMYFOOD}.`,

        OG: {
            TYPE: 'website',
            SITE_NAME: CONSTANT.OMYFOOD,
            TITLE: `Restaurants Near You • ${CONSTANT.OMYFOOD}`,
            DESCRIPTION: 'Explore trending food places nearby. View ratings, distance, and place an order in seconds.',
        },

        TWITTER: {
            TITLE: `Find Local Restaurants & Order Instantly | ${CONSTANT.OMYFOOD}`,
            DESCRIPTION: `Search local food spots, check reviews, and enjoy fast ordering via ${CONSTANT.OMYFOOD}.`,
        },
        KEYWORDS:
    'nearby restaurants, local food places, find restaurants, food delivery, restaurant ratings, best local eateries, food near me, OMF restaurants'
    },

    USERS_PAGE: {
        TITLE: `Users | ${CONSTANT.OMYFOOD}`,
        DESCRIPTION:
    `Browse popular food bloggers and creators on ${CONSTANT.OMYFOOD}. Follow your favourite profiles and stay inspired by new recipes, reels, and restaurant reviews.`,

        OG: {
            TYPE: 'website',
            SITE_NAME: CONSTANT.OMYFOOD,
            TITLE: `Top Food Creators to Follow • ${CONSTANT.OMYFOOD}`,
            DESCRIPTION: 'Find and follow talented food bloggers sharing recipes, reviews, and cooking tips.',
        },

        TWITTER: {
            TITLE: `Find Food Bloggers & Follow Their Journey | ${CONSTANT.OMYFOOD}`,
            DESCRIPTION: 'Explore profiles, see follower counts, and connect with food lovers worldwide.',
        },

        KEYWORDS:
    'food bloggers, food creators, follow chefs, cooking influencers, recipe bloggers, OMF users, culinary profiles, food community, follow food accounts'
    }
};

